import { Button, Item, ItemActions, ItemContent, ItemHeader, ItemTitle } from '@ibsys/kit';
import { FC } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AttributeFormValues } from '../validation';
import { StructureGroupItem } from './StructureGroupItem';

type Props = {
  disabled?: boolean;
};

export const StructureGroupsList: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation(['attributes', 'common']);
  const { control, watch } = useFormContext<AttributeFormValues>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'structure.groups',
  });

  const structureAttributes = watch('structure.attributes') ?? [];

  const handleAdd = () => {
    // Create empty group with items for each attribute
    const items: Record<string, { code: string; value: string; description?: string }> = {};
    structureAttributes.forEach((attr) => {
      if (attr.code) {
        items[attr.code] = {
          code: '',
          value: '',
          description: '',
        };
      }
    });
    append({ items });
  };

  return (
    <Item variant="muted" className="w-full">
      <ItemHeader>
        <ItemTitle>{t('attributes:referenceValues')}</ItemTitle>
        <ItemActions>
          {!disabled && (
            <Button variant="secondary" size="sm" onClick={handleAdd}>
              {t('attributes:addValue')}
            </Button>
          )}
        </ItemActions>
      </ItemHeader>
      <ItemContent>
        <div className="flex flex-col gap-3">
          {fields.map((field, index) => (
            <StructureGroupItem
              key={field.id}
              index={index}
              disabled={disabled}
              onRemove={() => remove(index)}
              structureAttributes={structureAttributes}
            />
          ))}
          {fields.length === 0 && <p className="text-sm text-muted-foreground">{t('attributes:noReferenceValues')}</p>}
        </div>
      </ItemContent>
    </Item>
  );
};
